import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { LoginContainer } from '../ReportingLoginContainer/ReportingLoginContainer';
import {
  Description,
  Heading,
  IconContainer,
} from './ReportingActivateSuccess.styles';

export const ReportingActivateSuccess = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const emptyStateSrc = theme.isVaultVariant
    ? '/assets/empty-state.svg'
    : '/assets/empty-state-atlas.svg';
  return (
    <LoginContainer>
      <IconContainer>
        <img src={emptyStateSrc} alt="Empty state" width="100%" />
      </IconContainer>
      <Heading>{t('reporting.ReportingActivate.successHeading')}</Heading>
      <Description>
        {t('reporting.ReportingActivate.successAccount')}
      </Description>
      <Description>{t('reporting.ReportingActivate.successEmail')}</Description>
    </LoginContainer>
  );
};
